import { Box } from '@material-ui/core'
import { FunctionComponent } from 'react'
import { Modal } from 'components/core/modal'

import { Logo } from 'components/page/logo'
import { SummitTicketConfirmationDetails } from './SummitTicketConfirmationDetails'
import { FrontendEvent } from 'common/types'
import { summitPalette } from '../summitPalette'

interface SummitTicketConfirmationProps {
  show: boolean
  onClose: Function
  theme: any
  event: FrontendEvent
  isDevice: Boolean
}

export const SummitTicketConfirmation: FunctionComponent<SummitTicketConfirmationProps> = ({
  show,
  onClose,
  theme,
  event,
  isDevice
}) => {
  return (
    <Modal showCancel show={show} onClose={onClose} title="" noBorder dialogWidth="sm" backgroundColor={summitPalette.BackgroundColor}>
      <Box width="100%" padding={isDevice ? 0 : '0 1em 1em 1em'}>
        <Box display="flex" justifyContent="center" marginBottom="1em">
          <Logo noBorder bright isSummit notClickable />
        </Box>
        <SummitTicketConfirmationDetails theme={theme} event={event} isDevice={isDevice} />
      </Box>
    </Modal>
  )
}
